import { BrowserRouter, Navigate, Route, Routes, } from "react-router-dom";
import Loader from "./components/Common/Loader";
import React from "react";
import { AuthProvider } from "./hooks/useAuth";
import { ProtectedRoute } from "./components/ProtectedRoute";
import BackgroundVideo from "./components/Common/BackgroundVideo";

const LandingPage = React.lazy(() => import('./components/LandingPage/LandingPage'));
const LoginPage = React.lazy(() => import('./components/LoginPageComponents/LoginPage'));
const ScoreUrl = React.lazy(() => import('./components/ScoreUrl/ScoreUrl'));

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <Routes>
          <Route element={<BackgroundVideo />}>
            <Route
              path="/"
              element={
                <React.Suspense fallback={<Loader isLoading />}>
                  <ProtectedRoute>
                    <LandingPage title={"Score"} />
                  </ProtectedRoute>
                </React.Suspense>
              }
            />
          </Route>
          {/* Each ScoreUrl tab gets its own flat URL so a refresh or a direct
              link lands back on that tab instead of always resetting to
              Artist URLs. */}
          <Route
            path="/artist_urls"
            element={
              <React.Suspense fallback={<Loader isLoading />}>
                <ProtectedRoute>
                  <ScoreUrl title={"Artist URLs"} />
                </ProtectedRoute>
              </React.Suspense>
            }
          />
          <Route
            path="/weekly_urls"
            element={
              <React.Suspense fallback={<Loader isLoading />}>
                <ProtectedRoute>
                  <ScoreUrl title={"Weekly URLs"} />
                </ProtectedRoute>
              </React.Suspense>
            }
          />
          <Route path="/login" element={
            <React.Suspense fallback={<Loader isLoading />}>
              <LoginPage title={"Login"} />
            </React.Suspense>
          }
          />
          <Route path="*" element={<Navigate to='/' replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
